exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-range-picker[data-v-c7384b3a] .v-btn__content {\n    z-index: 1;\n}\n.date-range-picker[data-v-c7384b3a] .v-date-picker-table__events {\n    height: 100%;\n    width: 100%;\n    bottom: 0;\n    z-index: 0;\n}\n.date-range-picker[data-v-c7384b3a] .v-date-picker-table__events .date-in-range {\n    height: 100%;\n    width: 100%;\n    bottom: 0;\n    z-index: 0;\n    margin: 0;\n}\n", ""]);

// exports
